<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 170 170"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="85"
      cy="85"
      r="82"
      stroke="currentColor"
      stroke-width="6"
    />
    <path
      d="M32 68L32.3433 67.531C42.2215 54.0389 62.4437 54.2781 72 68V68"
      stroke="currentColor"
      stroke-width="4"
    />
    <path
      d="M98 68L98.3433 67.531C108.221 54.0389 128.444 54.2781 138 68V68"
      stroke="currentColor"
      stroke-width="4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55 112C55 111.448 55.4477 111 56 111H115C115.552 111 116 111.448 116 112V117C116 126.941 102.345 135 85.5 135C68.6553 135 55 126.941 55 117V112ZM64 116C63.4477 116 63 116.448 63 117V119C63 119.552 63.4477 120 64 120H108C108.552 120 109 119.552 109 119V117C109 116.448 108.552 116 108 116H64Z"
      fill="currentColor"
    />
  </svg>
</template>
